module.exports = __webpack_public_path__ + "static/media/Feb14-S19.7c3e5293.png";